const DOMAIN_PRODUCTION = "goita.ara.cat";
const DOMAIN_STAGING = "goita.staging.ara.cat";
const DOMAIN_DEVELOPMENT = "goita.dev.ara.cat";

const defaults = {
  KEYCLOAK_CLIENT_ID: "",
  KEYCLOAK_REALM: "",
  KEYCLOAK_URL: "",
  API_HEADER_KEY: "",
  API_HEADER_VALUE: "",
  APP_CHAT_MANAGER_API_URL: window.location.origin
};

const variables = {
  local: {
    ...defaults,
    APP_CHAT_MANAGER_API_URL:
      (import.meta.env.VITE_APP_CHAT_MANAGER_API_URL as string) ||
      defaults.APP_CHAT_MANAGER_API_URL,
    API_HEADER_KEY:
      (import.meta.env.VITE_API_HEADER_KEY as string) ||
      defaults.API_HEADER_KEY,
    API_HEADER_VALUE:
      (import.meta.env.VITE_API_HEADER_VALUE as string) ||
      defaults.API_HEADER_VALUE
  },
  development: {
    ...defaults,
    API_HEADER_KEY: "X-API-TOKEN",
    API_HEADER_VALUE: "wPE15dNLsA0o4YV3RURVVSzuHtvab3"
  },
  staging: {
    ...defaults,
    API_HEADER_KEY: "X-API-TOKEN",
    API_HEADER_VALUE: ""
  },
  production: {
    ...defaults,
    API_HEADER_KEY: "X-API-TOKEN",
    API_HEADER_VALUE: "1Y5utyJTcD0yHX0zUAO0AGnItQUV6U"
  }
};

const getVariables = () => {
  if (window.location.host === DOMAIN_PRODUCTION) {
    return variables.production;
  }

  if (window.location.host === DOMAIN_STAGING) {
    return variables.staging;
  }

  if (window.location.host === DOMAIN_DEVELOPMENT) {
    return variables.development;
  }

  return variables.local;
};

export const {
  KEYCLOAK_CLIENT_ID,
  KEYCLOAK_REALM,
  KEYCLOAK_URL,
  API_HEADER_KEY,
  API_HEADER_VALUE,
  APP_CHAT_MANAGER_API_URL
} = getVariables();

// ARA Login URL - URL a la que redirigir si el usuario no está logueado
export const ARA_LOGIN_URL = "https://www.ara.cat/usuari/login?backUrl=";

// Conversation retention period in days
export const CONVERSATION_RETENTION_DAYS = 15;
